module.exports = __webpack_public_path__ + "static/media/handWipes.2d26dd1c.svg";